import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getCustomerProfileConfig } from '../../../selectors/customerProfileSelectors';
import { editPolicyInfoBanner } from '../../../types/editPolicyInfo';
import {
  resolveLocalizedText,
  resolvePublicAssets,
  isApp,
} from '../../../../../utils';
import { goto, goToView } from '../../../../../actions/historyActions';
import './index.scss';
import { SmallButton } from '@axa-asia/emma-stylesheet';

export interface ChangeContactBannerProps {
  editPolicyInfoBanner: editPolicyInfoBanner;
}

export interface ChangeContactBannerState {}

export class ChangeContactBanner extends Component<
  ChangeContactBannerProps,
  ChangeContactBannerState
> {
  constructor(props: any) {
    super(props);
    this.state = {};
    this.handleContactUs = this.handleContactUs.bind(this);
  }

  handleContactUs() {
    if (isApp()) {
      goToView('emma-life/generic-support');
    } else {
      goto('emma-life/generic-support');
    }
  }

  render() {
    const { editPolicyInfoBanner } = this.props;
    const { icon, title, desc, buttonText } = editPolicyInfoBanner;
    return (
      <div className="change-contant-intr">
        <img
          src={
            icon
              ? resolvePublicAssets(
                  `assets/${icon
                    .replace('images/', 'images/customer-profile/')
                    .replace('.png', '@3x.png')}`,
                )
              : ''
          }
          alt=""
        />
        <div>
          <div className="change-contant-intr-text">
            {title ? resolveLocalizedText(title) : ''}
          </div>
          <div>{desc ? resolveLocalizedText(desc) : ''}</div>
          <div>
            <SmallButton
              onClick={this.handleContactUs}
              varient="ghost"
              className="mt-3"
              data-enable-ga
              data-ga-type="button"
            >
              {buttonText ? resolveLocalizedText(buttonText) : ''}
            </SmallButton>
          </div>
        </div>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const config = getCustomerProfileConfig(state) || {};
    return {
      editPolicyInfoBanner: config.editPolicyInfoBanner || {},
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {};
  }
}

export default connect(
  ChangeContactBanner.mapStateToProps,
  ChangeContactBanner.mapDispatchToProps,
)(ChangeContactBanner);
